import React from 'react'
import { Document, Page, View, Text, StyleSheet } from '@react-pdf/renderer'
import Header from './Header'
import Title from './Title'
import ReportBody from './ReportBody'

const ReportsDocument = ({ commitment, author, startingDate, endingDate, operations }) => {

    console.log(operations)

    return (
        <Document>
            <Page size="A4" style={styles.body}>
                <View>
                    <Header />
                    <Title
                        author={author}
                        endingDate={endingDate}
                        startingDate={startingDate}
                        commitment={commitment}
                    />
                    <ReportBody
                        operations={operations}
                    />  
                </View>
            </Page>
        </Document>

    )

}

export default ReportsDocument


const styles = StyleSheet.create({
    body: {
        paddingTop: 35,
        paddingBottom: 65,
        paddingHorizontal: 35,
    },
    headerWithBorder: {
        fontSize: 20,
        paddingBottom: 10,
        borderBottom: '1px solid grey',
        marginBottom: 10,
    },
    h3: {
        fontSize: 12,
    },
    boldText: {
        fontSize: 12,
        fontWeight: 'bold',
        marginBottom: 5,
    },
    text: {
        fontSize: 10,
    },
    
})


// WEBPACK FOOTER //
// ./src/components/printable/ReportsDocument.jsx